import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import WorkerSubTaskList from './WorkerSubTaskList';
//import { spinnerWhileLoading } from '../../utils/components';


const enhance = compose(
        firebaseConnect((props, store) => {
        //const encodedEmail = window.btoa(store.getState().firebase.auth.email);
        return [{
            path: 'subTasks', queryParams: ['orderByChild=assignedTo', 'limitToFirst=10']
        }];
    }),
    connect(
        (state, props) => {
            return ({
                auth: state.firebase.auth,
            });
        }
    )
);

export default enhance(WorkerSubTaskList);



// WEBPACK FOOTER //
// ./src/components/Tasks/WorkerSubTaskList.enhancer.js